export default "__VITE_ASSET__DdGd9ps1__"